import './index.css';
import React, { ReactPortal } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Version from './components/Version';
import createVersionPortal from './lib/helper/create-version-portal';
import loadAnalytics from './lib/analytics/load-analytics';
import { initiliazeMsalInstance } from './lib/api/auth';
import setEnvVarsToSession from "./lib/helper/set-env-vars-to-session";

const startApp = async () => {
    await setEnvVarsToSession();
    await initiliazeMsalInstance();

    const element: HTMLElement | null = document.getElementById('root');
    const root = ReactDOM.createRoot(element as Element);
    root.render(
        <React.StrictMode>
            <App />
            {await createVersionPortal(<Version />, 'version', ['dev']) as ReactPortal}
        </React.StrictMode>
    );

    loadAnalytics();
};

startApp();
